(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-general"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.cgs');
  if(!root)return;
  var freeShip=(parseFloat(root.getAttribute('data-free-ship'))||48)*100;
  var qtys={};
  function money(c){return '$'+(c/100).toFixed(2)}
  function toast(t){var e=root.querySelector('[data-toast]');if(!e)return;e.textContent=t;e.classList.add('is-show');clearTimeout(e._t);e._t=setTimeout(function(){e.classList.remove('is-show')},1600)}
  function syncCart(){
    fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.json()}).then(function(c){
      root.querySelectorAll('[data-cart-count]').forEach(function(e){e.textContent=c.item_count});
      root.querySelectorAll('[data-cart-total]').forEach(function(e){e.textContent=money(c.total_price)});
      root.querySelectorAll('[data-reward]').forEach(function(e){
        if(c.total_price>=freeShip)e.textContent='Free shipping unlocked';
        else e.textContent='Add '+money(freeShip-c.total_price)+' for free shipping';
      });
    }).catch(function(){});
  }
  function addLines(items,label,btn){
    if(btn)btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json()}).then(function(){toast(label);syncCart();if(btn)btn.disabled=false;})
      .catch(function(){toast('Could not add — try again');if(btn)btn.disabled=false;});
  }
  root.querySelectorAll('.cgs-qty').forEach(function(q){
    var id=q.getAttribute('data-qty-for'),n=q.querySelector('[data-qty-n]');
    qtys[id]=0;
    q.querySelector('[data-qty-plus]').addEventListener('click',function(){qtys[id]++;n.textContent=qtys[id]});
    q.querySelector('[data-qty-minus]').addEventListener('click',function(){qtys[id]=Math.max(0,qtys[id]-1);n.textContent=qtys[id]});
  });
  root.querySelectorAll('[data-add]').forEach(function(b){
    b.addEventListener('click',function(){
      var id=b.getAttribute('data-add');var qty=qtys[id]&&qtys[id]>0?qtys[id]:1;
      addLines([{id:parseInt(id,10),quantity:qty}],(b.getAttribute('data-title')||'Item')+' added to cart',b);
    });
  });
  root.querySelectorAll('.cgs-card__vis').forEach(function(vis){
    var gal=vis.querySelector('[data-gallery]');if(!gal)return;
    var dots=vis.querySelectorAll('.cgs-card__dot');
    if(dots.length)dots[0].classList.add('is-active');
    function update(){var w=gal.clientWidth||1;var idx=Math.round(gal.scrollLeft/w);dots.forEach(function(d,i){d.classList.toggle('is-active',i===idx);});}
    gal.addEventListener('scroll',function(){clearTimeout(gal._gt);gal._gt=setTimeout(update,60);});
    vis.querySelectorAll('[data-gnav]').forEach(function(b){
      b.addEventListener('click',function(){
        var dir=parseInt(b.getAttribute('data-gnav'),10)||1;
        var w=gal.clientWidth||1;
        var n=gal.querySelectorAll('.cgs-card__slide').length;
        var idx=Math.round(gal.scrollLeft/w)+dir;
        if(idx>=n)idx=0; else if(idx<0)idx=n-1;   // loop back to the main image
        gal.scrollTo({left:idx*w,behavior:'smooth'});
      });
    });
  });
  syncCart();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"]) return;
  try {
    
(function () {
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
  }, { threshold: 0.1 });
  document.querySelectorAll('.scusa-reveal').forEach(function (el) { observer.observe(el); });
  setTimeout(function () {
    document.querySelectorAll('.scusa-reveal').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('visible');
    });
  }, 100);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-lineup-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
  }, { threshold: 0.1 });
  document.querySelectorAll('.scusa-reveal').forEach(function (el) { observer.observe(el); });
  setTimeout(function () {
    document.querySelectorAll('.scusa-reveal').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('visible');
    });
  }, 100);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window._scusaRevealInit) return;
window._scusaRevealInit = true;
var obs = new IntersectionObserver(function(entries){
entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('visible'); obs.unobserve(e.target); }});
  },{threshold:0.08});
function observe(){ document.querySelectorAll('.scusa-reveal:not(.visible)').forEach(function(el){ obs.observe(el); }); }
observe();
setTimeout(function(){
document.querySelectorAll('.scusa-reveal').forEach(function(el){
if(el.getBoundingClientRect().top < window.innerHeight) el.classList.add('visible');
    });
observe();
  },150);
document.querySelectorAll('.cpg2-faq__q').forEach(function(btn){
btn.addEventListener('click', function(){
var item = this.closest('.cpg2-faq__item');
var isOpen = item.classList.contains('open');
document.querySelectorAll('.cpg2-faq__item.open').forEach(function(i){ i.classList.remove('open'); });
if(!isOpen) item.classList.add('open');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-stripper-clips-mobile"]) return;
  try {
    
(function(){
  // One .csc per page (the section is gated to a single collection), so a single root lookup is enough.
  var root=document.querySelector('.csc');
  if(!root)return;
  var freeShip=(parseFloat(root.getAttribute('data-free-ship'))||48)*100;
  var qtys={};
  function money(c){return '$'+(c/100).toFixed(2)}
  function toast(t){var e=root.querySelector('[data-toast]');if(!e)return;e.textContent=t;e.classList.add('is-show');clearTimeout(e._t);e._t=setTimeout(function(){e.classList.remove('is-show')},1600)}
  function syncCart(){
    fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.json()}).then(function(c){
      root.querySelectorAll('[data-cart-count]').forEach(function(e){e.textContent=c.item_count});
      root.querySelectorAll('[data-cart-total]').forEach(function(e){e.textContent=money(c.total_price)});
      root.querySelectorAll('[data-reward]').forEach(function(e){
        if(c.total_price>=freeShip)e.textContent='Free shipping unlocked';
        else e.textContent='Add '+money(freeShip-c.total_price)+' for free shipping';
      });
    }).catch(function(){});
  }
  function addLines(items,label,btn){
    if(btn)btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json()}).then(function(){toast(label);syncCart();if(btn)btn.disabled=false;})
      .catch(function(){toast('Could not add — try again');if(btn)btn.disabled=false;});
  }
  // qty steppers
  root.querySelectorAll('.csc-qty').forEach(function(q){
    var id=q.getAttribute('data-qty-for'),n=q.querySelector('[data-qty-n]');
    qtys[id]=0;
    q.querySelector('[data-qty-plus]').addEventListener('click',function(){qtys[id]++;n.textContent=qtys[id]});
    q.querySelector('[data-qty-minus]').addEventListener('click',function(){qtys[id]=Math.max(0,qtys[id]-1);n.textContent=qtys[id]});
  });
  // add to cart (uses the card's chosen qty, min 1)
  root.querySelectorAll('[data-add]').forEach(function(b){
    b.addEventListener('click',function(){
      var id=b.getAttribute('data-add');var qty=qtys[id]&&qtys[id]>0?qtys[id]:1;
      addLines([{id:parseInt(id,10),quantity:qty}],(b.getAttribute('data-title')||'Item')+' added to cart',b);
    });
  });
  // add all three
  root.querySelectorAll('[data-add-bundle]').forEach(function(b){
    b.addEventListener('click',function(){
      var ids=(b.getAttribute('data-add-bundle')||'').split(',').filter(Boolean);
      if(!ids.length)return;
      addLines(ids.map(function(i){return {id:parseInt(i,10),quantity:1}}),'All colors added to cart',b);
    });
  });
  // per-card image gallery: native swipe + arrow buttons + dot sync
  root.querySelectorAll('.csc-card__visual').forEach(function(vis){
    var gal=vis.querySelector('[data-gallery]');if(!gal)return;
    var dots=vis.querySelectorAll('.csc-card__dot');
    if(dots.length)dots[0].classList.add('is-active');
    function update(){var w=gal.clientWidth||1;var idx=Math.round(gal.scrollLeft/w);dots.forEach(function(d,i){d.classList.toggle('is-active',i===idx);});}
    gal.addEventListener('scroll',function(){clearTimeout(gal._gt);gal._gt=setTimeout(update,60);});
    vis.querySelectorAll('[data-gnav]').forEach(function(b){
      b.addEventListener('click',function(){
        var dir=parseInt(b.getAttribute('data-gnav'),10)||1;
        var w=gal.clientWidth||1;
        var n=gal.querySelectorAll('.csc-card__slide').length;
        var idx=Math.round(gal.scrollLeft/w)+dir;
        if(idx>=n)idx=0; else if(idx<0)idx=n-1;   // loop back to the main image
        gal.scrollTo({left:idx*w,behavior:'smooth'});
      });
    });
  });
  syncCart();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-coded-system"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ccvInit === '1') return;
    root.dataset.ccvInit = '1';
    var cards = root.querySelectorAll('[data-ccv-color]');
    var nameEls = root.querySelectorAll('[data-ccv-selected-name]');
    var purposeEls = root.querySelectorAll('[data-ccv-selected-purpose]');
    var clips = root.querySelectorAll('[data-ccv-clip]');
    function select(card){
      cards.forEach(function(c){ c.classList.remove('is-active'); c.setAttribute('aria-pressed','false'); });
      card.classList.add('is-active');
      card.setAttribute('aria-pressed','true');
      var name = card.getAttribute('data-name');
      var purpose = card.getAttribute('data-purpose');
      var key = card.getAttribute('data-key');
      nameEls.forEach(function(e){ e.textContent = name; });
      purposeEls.forEach(function(e){ e.textContent = purpose; });
      clips.forEach(function(cl){ cl.classList.toggle('is-active', cl.getAttribute('data-key') === key); });
    }
    cards.forEach(function(card){
      card.addEventListener('click', function(e){
        var shop = e.target.closest('[data-ccv-shop]');
        if(shop){ var href = shop.getAttribute('data-href'); if(href){ window.location.href = href; } return; }
        select(card);
      });
    });

    // compatibility checker
    var checker = root.querySelector('[data-ccv-checker]');
    if(checker){
      var resBox = checker.querySelector('[data-ccv-res]');
      var resT = checker.querySelector('[data-ccv-res-t]');
      var resC = checker.querySelector('[data-ccv-res-c]');
      function val(n){ var el = checker.querySelector('input[name^="ccv-' + n + '-"]:checked'); return el ? el.value : ''; }
      function evaluate(){
        var cal = val('cal'), ld = val('loader');
        var good = cal === '556' && ld === 'striplula';
        var t, c;
        if(good){ t = checker.getAttribute('data-good-t'); c = checker.getAttribute('data-good-c'); }
        else if(ld === 'metal'){ t = checker.getAttribute('data-loader-t'); c = checker.getAttribute('data-loader-c'); }
        else { t = checker.getAttribute('data-cal-t'); c = checker.getAttribute('data-cal-c'); }
        resBox.classList.toggle('is-bad', !good);
        resBox.classList.toggle('is-good', good);
        resT.textContent = t;
        resC.textContent = c;
      }
      checker.querySelectorAll('input[type="radio"]').forEach(function(i){ i.addEventListener('change', evaluate); });
      evaluate();
    }

    // per-product review popups
    function closeModals(){ root.querySelectorAll('.ccv-revmodal').forEach(function(m){ m.hidden = true; }); document.body.classList.remove('ccv-revmodal-open'); }
    root.querySelectorAll('[data-ccv-revopen]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var m = root.querySelector('[id="' + btn.getAttribute('data-ccv-revopen') + '"]');
        if(!m) return;
        closeModals();
        m.hidden = false;
        document.body.classList.add('ccv-revmodal-open');
        var list = m.querySelector('.ccv-revmodal__list'); if(list) list.scrollTop = 0;
        var x = m.querySelector('.ccv-revmodal__x'); if(x) x.focus();
      });
    });
    root.querySelectorAll('[data-ccv-revclose]').forEach(function(el){ el.addEventListener('click', closeModals); });
    if(!root.dataset.ccvEsc){ root.dataset.ccvEsc = '1'; document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeModals(); }); }
  }
  function boot(){ document.querySelectorAll('[data-ccv]').forEach(init); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('[data-ccv]');
    if(root){ root.dataset.ccvInit = ''; init(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('scusa-footer');
  if(!root) return;
  var toast = document.getElementById('scusa-footer-toast');
  function ping(msg){ if(!toast) return; toast.textContent=msg; toast.classList.add('show'); clearTimeout(toast._t); toast._t=setTimeout(function(){toast.classList.remove('show');},1800); }

  // Accordion (mobile) — one open at a time. Harmless on desktop (links are always shown via CSS).
  root.querySelectorAll('.ft-col-head').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(window.matchMedia('(min-width:990px)').matches) return;
      var col = btn.parentElement, wasOpen = col.classList.contains('ft-col--open');
      root.querySelectorAll('.ft-col').forEach(function(c){ c.classList.remove('ft-col--open'); var i=c.querySelector('.ft-acc-ind'); if(i) i.textContent='+'; var h=c.querySelector('.ft-col-head'); if(h) h.setAttribute('aria-expanded','false'); });
      if(!wasOpen){ col.classList.add('ft-col--open'); var i=btn.querySelector('.ft-acc-ind'); if(i) i.textContent='−'; btn.setAttribute('aria-expanded','true'); }
    });
  });

  // Newsletter — real Klaviyo subscribe is wired site-wide by assets/scusa-footer-signup.js (baked into the theme).

  // Back to top (desktop bottom bar)
  var back = root.querySelector('.ft-back');
  if(back){ back.addEventListener('click', function(){ window.scrollTo({top:0,behavior:'smooth'}); }); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guides-hub-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-ghv]');
  roots.forEach(function (root) {
    /* Reduced-motion: pause the decorative hero video and show its current frame. */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('.ghv-hero__video').forEach(function (v) {
        v.removeAttribute('autoplay');
        try { v.pause(); } catch (e) {}
      });
    }

    /* Guide library: text search over cards (hides empty category groups); topic nav jumps to sections. */
    var articles = [].slice.call(root.querySelectorAll('[data-ghv-article]'));
    var groups = [].slice.call(root.querySelectorAll('[data-ghv-group]'));
    var navLinks = [].slice.call(root.querySelectorAll('[data-ghv-nav]'));
    var searchInputs = [].slice.call(root.querySelectorAll('[data-ghv-search]'));
    var count = root.querySelector('[data-ghv-count]');
    var empty = root.querySelector('[data-ghv-empty]');

    function applySearch() {
      var q = '';
      searchInputs.forEach(function (i) { if (i.value) { q = i.value.trim().toLowerCase(); } });
      var visible = 0;
      articles.forEach(function (a) {
        var text = a.getAttribute('data-text') || '';
        var show = !q || text.indexOf(q) !== -1;
        a.hidden = !show;
        if (show) { visible++; }
      });
      groups.forEach(function (g) { g.hidden = !g.querySelector('[data-ghv-article]:not([hidden])'); });
      if (count) { count.textContent = visible + (visible === 1 ? ' guide' : ' guides'); }
      if (empty) { empty.hidden = visible !== 0; }
    }
    searchInputs.forEach(function (i) { i.addEventListener('input', applySearch); });

    /* Topic nav = native anchor jumps (smooth via the theme's global scroll-behavior; robust to layout shift).
       Clear any active search first so the target section is visible, then let the browser navigate. */
    navLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        searchInputs.forEach(function (i) { i.value = ''; });
        applySearch();
        navLinks.forEach(function (l) { l.classList.toggle('is-active', l === link); });
      });
    });

    /* Hero search form: filter in place + jump to the library. */
    var form = root.querySelector('[data-ghv-searchform]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        applySearch();
        window.location.hash = 'ghv-library';
      });
    }

    /* Scrollspy: highlight the topic whose section is in view. */
    function onScroll() {
      var currentTag = 'all';
      groups.forEach(function (g) {
        if (!g.hidden && g.getBoundingClientRect().top <= 120) { currentTag = g.id.replace('ghv-cat-', ''); }
      });
      navLinks.forEach(function (l) { l.classList.toggle('is-active', (l.getAttribute('data-ghv-nav') || 'all') === currentTag); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* Article share — Web Share API on supported devices, copy-to-clipboard fallback elsewhere. */
    root.querySelectorAll('[data-ghv-share]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var url = btn.getAttribute('data-url');
        var title = btn.getAttribute('data-title');
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            btn.classList.add('is-copied');
            setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
          }).catch(function () {});
        }
      });
    });

    /* FAQ accordion (single-open). */
    var faqItems = [].slice.call(root.querySelectorAll('.ghv-faq__item'));
    faqItems.forEach(function (item) {
      var q = item.querySelector('.ghv-faq__q');
      if (!q) { return; }
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        faqItems.forEach(function (row) {
          row.classList.remove('is-open');
          var rq = row.querySelector('.ghv-faq__q');
          if (rq) { rq.setAttribute('aria-expanded', 'false'); }
        });
        if (!isOpen) {
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });

    applySearch();
  });

  /* Scroll reveal (matches the store-wide .scusa-reveal pattern). */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
  }, { threshold: 0.1 });
  document.querySelectorAll('.ghv .scusa-reveal').forEach(function (el) { observer.observe(el); });
  setTimeout(function () {
    document.querySelectorAll('.ghv .scusa-reveal').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('visible'); }
    });
  }, 100);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-v2body"] && !Shopify.designMode) return;
  try {
    
(function () {
  var lb = document.getElementById('v2b-lightbox'), lbimg = lb ? lb.querySelector('img') : null;
  function closeLb() { if (lb) lb.hidden = true; }
  function closeAll() { document.querySelectorAll('.v2b-modal').forEach(function (m) { m.hidden = true; }); document.body.classList.remove('v2b-modal-open'); }
  document.querySelectorAll('[data-v2bmodal]').forEach(function (btn) {
    btn.addEventListener('click', function () { var m = document.getElementById(btn.getAttribute('data-v2bmodal')); if (m) { closeAll(); m.hidden = false; document.body.classList.add('v2b-modal-open'); var l = m.querySelector('.v2b-modal-list'); if (l) l.scrollTop = 0; } });
  });
  document.querySelectorAll('[data-v2bclose]').forEach(function (el) { el.addEventListener('click', closeAll); });
  document.querySelectorAll('[data-v2bfull]').forEach(function (t) { t.addEventListener('click', function (e) { e.stopPropagation(); if (lbimg) { lbimg.src = t.getAttribute('data-v2bfull'); lb.hidden = false; } }); });
  if (lb) lb.addEventListener('click', closeLb);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (lb && !lb.hidden) { closeLb(); } else { closeAll(); } } });
})();
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Numbers ship with their real value in the HTML (crawlers/no-JS/SR see 4×/200+/5.0★); reset to 0 for motion users so the scroll-in count-up runs.
  if (!reduce) { document.querySelectorAll('.v2b-num').forEach(function (n) { var dec = parseInt(n.getAttribute('data-dec') || '0', 10); var suf = n.querySelector('.v2b-u'); n.innerHTML = (0).toFixed(dec) + (suf ? suf.outerHTML : ''); }); }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return; e.target.classList.add('v2b-in');
      if (e.target.classList.contains('v2b-stats')) cnt(e.target); io.unobserve(e.target);
    });
  }, { threshold: .2 });
  document.querySelectorAll('.v2b-reveal').forEach(function (el) { io.observe(el); });
  var st = document.querySelector('.v2b-stats'); if (st) io.observe(st);
  document.querySelectorAll('.v2b-vplay').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-yt');
      var f = document.createElement('div'); f.className = 'v2b-viframe';
      f.innerHTML = '<iframe src="https://www.youtube.com/embed/' + id + '?rel=0&modestbranding=1&color=white" title="SCUSA video" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      btn.replaceWith(f);
    });
  });
  function cnt(scope) {
    scope.querySelectorAll('.v2b-num').forEach(function (n) {
      var to = parseFloat(n.getAttribute('data-to')), dec = parseInt(n.getAttribute('data-dec') || '0', 10);
      var suf = n.querySelector('.v2b-u'), sh = suf ? suf.outerHTML : '';
      if (reduce) { n.innerHTML = to.toFixed(dec) + sh; return; }
      var s = null, d = 1100;
      function step(ts) { if (!s) s = ts; var p = Math.min((ts - s) / d, 1), e = 1 - Math.pow(1 - p, 3); n.innerHTML = (to * e).toFixed(dec) + sh; if (p < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kits-comparison"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__scKR) return;
  window.__scKR = 1;

  function perView() {
    var w = window.innerWidth;
    return w <= 600 ? 1 : (w <= 900 ? 2 : 3);
  }
  function slideCount(modal) {
    return modal.querySelectorAll('.sc-kr__slide').length;
  }
  function pageCount(modal) {
    return Math.max(1, Math.ceil(slideCount(modal) / perView()));
  }
  function buildDots(modal) {
    var wrap = modal.querySelector('.sc-kr__dots');
    if (!wrap) return;
    var total = pageCount(modal);
    wrap.innerHTML = '';
    for (var i = 0; i < total; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sc-kr__dot';
      b.setAttribute('data-kr-dot', i);
      wrap.appendChild(b);
    }
  }
  function setPage(modal, p) {
    var total = pageCount(modal);
    if (p < 0) p = 0;
    if (p > total - 1) p = total - 1;
    modal.__page = p;
    var vp = modal.querySelector('.sc-kr__viewport');
    if (vp) vp.scrollTo({ left: p * vp.clientWidth, behavior: 'smooth' });
    var dots = modal.querySelectorAll('.sc-kr__dot');
    for (var i = 0; i < dots.length; i++) {
      if (i === p) dots[i].classList.add('is-active');
      else dots[i].classList.remove('is-active');
    }
  }
  function openModal(id) {
    var m = document.getElementById(id);
    if (!m) return;
    if (m.parentNode !== document.body) document.body.appendChild(m);
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    buildDots(m);
    setPage(m, 0);
  }
  function closeModal(m) {
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-kr-open]');
    if (open) { e.preventDefault(); openModal(open.getAttribute('data-kr-open')); return; }
    var close = e.target.closest('[data-kr-close]');
    if (close) { var m1 = close.closest('.sc-kr__modal'); if (m1) closeModal(m1); return; }
    var prev = e.target.closest('[data-kr-prev]');
    if (prev) { var m2 = prev.closest('.sc-kr__modal'); if (m2) setPage(m2, (m2.__page || 0) - 1); return; }
    var next = e.target.closest('[data-kr-next]');
    if (next) { var m3 = next.closest('.sc-kr__modal'); if (m3) setPage(m3, (m3.__page || 0) + 1); return; }
    var dot = e.target.closest('[data-kr-dot]');
    if (dot) { var m4 = dot.closest('.sc-kr__modal'); if (m4) setPage(m4, parseInt(dot.getAttribute('data-kr-dot'), 10)); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var m = document.querySelector('.sc-kr__modal.is-open');
      if (m) closeModal(m);
    }
  });
  window.addEventListener('resize', function () {
    var m = document.querySelector('.sc-kr__modal.is-open');
    if (m) { buildDots(m); setPage(m, m.__page || 0); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-collections-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-lcv]');
  roots.forEach(function (root) {
    /* Route finder: selecting a route highlights it + rewrites the recommendation panel. */
    var routeBtns = root.querySelectorAll('[data-lcv-route]');
    var recTitle = root.querySelector('[data-lcv-rec-title]');
    var recCopy = root.querySelector('[data-lcv-rec-copy]');
    var recCta = root.querySelector('[data-lcv-rec-cta]');
    var recBtn = root.querySelector('[data-lcv-rec-btn]');
    routeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        routeBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (recTitle) { recTitle.textContent = btn.getAttribute('data-title') || ''; }
        if (recCopy) { recCopy.textContent = btn.getAttribute('data-copy') || ''; }
        if (recCta) { recCta.textContent = btn.getAttribute('data-cta') || ''; }
        if (recBtn) { recBtn.setAttribute('href', btn.getAttribute('data-url') || '#'); }
      });
    });

    /* Volume selector: selecting a tier updates the recommendation + CTA target. */
    var volBtns = root.querySelectorAll('[data-lcv-volume]');
    var volResult = root.querySelector('[data-lcv-volume-result]');
    var volBtn = root.querySelector('[data-lcv-volume-btn]');
    volBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        volBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (volResult) { volResult.textContent = btn.getAttribute('data-result') || ''; }
        if (volBtn) { volBtn.setAttribute('href', btn.getAttribute('data-url') || '#'); }
      });
    });
  });

  /* Scroll reveal (self-contained; matches the store-wide .scusa-reveal pattern). */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
  }, { threshold: 0.1 });
  document.querySelectorAll('.lcv .scusa-reveal').forEach(function (el) { observer.observe(el); });
  setTimeout(function () {
    document.querySelectorAll('.lcv .scusa-reveal').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('visible'); }
    });
  }, 100);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function () {
  function initRoot(root) {
    if (root.dataset.artvReady) return;
    root.dataset.artvReady = '1';
    var body = root.querySelector('[data-artv-body]');

    // TOC from H2s
    var tocUl = root.querySelector('[data-artv-toc]');
    if (tocUl && body) {
      var hs = body.querySelectorAll('h2');
      if (hs.length < 2) {
        var toc = tocUl.closest('.artv-toc');
        if (toc) toc.style.display = 'none';
      } else {
        hs.forEach(function (h, i) {
          if (!h.id) h.id = 'artv-h-' + i;
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          a.addEventListener('click', function (e) { e.preventDefault(); h.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
          li.appendChild(a);
          tocUl.appendChild(li);
        });
      }
    }

    // reading progress
    var bar = root.querySelector('[data-artv-progress]');
    if (bar) {
      var onScroll = function () {
        var d = document.documentElement;
        var total = d.scrollHeight - d.clientHeight;
        bar.style.width = (total > 0 ? (d.scrollTop / total * 100) : 0) + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // start-reading buttons
    root.querySelectorAll('[data-artv-start]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = document.getElementById('artv-article');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // font-size controls
    root.querySelectorAll('[data-artv-font]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!body) return;
        var size = parseFloat(getComputedStyle(body).fontSize);
        size += b.getAttribute('data-artv-font') === 'up' ? 1 : -1;
        size = Math.max(15, Math.min(22, size));
        body.style.fontSize = size + 'px';
      });
    });

    // share + copy
    root.querySelectorAll('[data-artv-share]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = window.location.href;
        if (navigator.share) { navigator.share({ title: document.title, url: url }).catch(function () {}); }
        else if (navigator.clipboard) { navigator.clipboard.writeText(url); b.textContent = '✓ Link copied'; }
      });
    });
    root.querySelectorAll('[data-artv-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-url') || window.location.href;
        if (navigator.clipboard) { navigator.clipboard.writeText(url); b.textContent = 'Copied!'; }
      });
    });
  }
  function boot() { document.querySelectorAll('[data-artv]').forEach(initRoot); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoot(root) {
    if (root.dataset.blgvReady) return;
    root.dataset.blgvReady = '1';
    var search = root.querySelector('[data-blgv-search]');
    var posts = Array.prototype.slice.call(root.querySelectorAll('[data-blgv-post]'));
    var countEl = root.querySelector('[data-blgv-count]');
    var emptyEl = root.querySelector('[data-blgv-empty]');
    var pager = root.querySelector('[data-blgv-pagination]');
    var library = root.querySelector('[data-blgv-library]');
    var filters = root.querySelectorAll('[data-blgv-filter]');
    var perPage = 9;
    var pv = library && library.getAttribute('data-per-page');
    if (pv) perPage = parseInt(pv, 10) || 9;
    var category = 'all';
    var page = 1;

    function render() {
      var term = (search && search.value || '').trim().toLowerCase();
      var matches = posts.filter(function (p) {
        var catOk = category === 'all' || p.getAttribute('data-category') === category;
        var textOk = !term || p.textContent.toLowerCase().indexOf(term) !== -1;
        return catOk && textOk;
      });
      var pages = Math.max(1, Math.ceil(matches.length / perPage));
      if (page > pages) page = pages;
      posts.forEach(function (p) { p.hidden = true; });
      matches.slice((page - 1) * perPage, page * perPage).forEach(function (p) { p.hidden = false; });
      if (countEl) countEl.textContent = matches.length + ' article' + (matches.length === 1 ? '' : 's');
      if (emptyEl) emptyEl.hidden = matches.length !== 0;
      buildPager(pages);
    }
    function buildPager(pages) {
      if (!pager) return;
      pager.innerHTML = '';
      if (pages <= 1) return;
      var prev = document.createElement('button');
      prev.type = 'button'; prev.textContent = '←'; prev.disabled = page === 1;
      prev.addEventListener('click', function () { if (page > 1) { page--; render(); scrollTop(); } });
      pager.appendChild(prev);
      for (var i = 1; i <= pages; i++) {
        (function (n) {
          var b = document.createElement('button');
          b.type = 'button'; b.textContent = n;
          if (n === page) b.className = 'is-active';
          b.addEventListener('click', function () { page = n; render(); scrollTop(); });
          pager.appendChild(b);
        })(i);
      }
      var next = document.createElement('button');
      next.type = 'button'; next.textContent = '→'; next.disabled = page === pages;
      next.addEventListener('click', function () { if (page < pages) { page++; render(); scrollTop(); } });
      pager.appendChild(next);
    }
    function scrollTop() { if (library) library.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        category = f.getAttribute('data-blgv-filter');
        page = 1;
        filters.forEach(function (x) { x.classList.toggle('is-active', x === f); });
        render();
        scrollTop();
      });
    });
    if (search) search.addEventListener('input', function () { page = 1; render(); });
    render();
  }
  function boot() { document.querySelectorAll('[data-blgv]').forEach(initRoot); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoot(root) {
    if (root.dataset.ctvReady) return;
    root.dataset.ctvReady = '1';
    var routes = root.querySelectorAll('.ctv-route');
    var bestTitle = root.querySelector('[data-ctv-best-title]');
    var bestCopy = root.querySelector('[data-ctv-best-copy]');
    var reasonSel = root.querySelector('[data-ctv-reason-field]');
    var go = root.querySelector('[data-ctv-go]');
    var formArea = root.querySelector('[data-ctv-form]');

    function setReason(val) {
      if (!reasonSel || !val) return;
      for (var i = 0; i < reasonSel.options.length; i++) {
        if (reasonSel.options[i].value === val || reasonSel.options[i].text === val) {
          reasonSel.selectedIndex = i;
          return;
        }
      }
    }
    routes.forEach(function (r) {
      r.addEventListener('click', function () {
        routes.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
        r.classList.add('is-active');
        r.setAttribute('aria-selected', 'true');
        if (bestTitle) bestTitle.textContent = r.getAttribute('data-ctv-title') || '';
        if (bestCopy) bestCopy.textContent = r.getAttribute('data-ctv-copy') || '';
        setReason(r.getAttribute('data-ctv-reason'));
      });
    });
    if (go && formArea) {
      go.addEventListener('click', function () {
        formArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var nameField = formArea.querySelector('#ctv-name');
        if (nameField) { window.setTimeout(function () { nameField.focus({ preventScroll: true }); }, 500); }
      });
    }
    var chat = root.querySelector('[data-ctv-chat]');
    if (chat) {
      chat.addEventListener('click', function (e) {
        e.preventDefault();
        window.dispatchEvent(new Event('flyweightchatopen'));
      });
    }
  }
  function boot() { document.querySelectorAll('[data-ctv]').forEach(initRoot); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
document.querySelectorAll('.scusa-faq-item__q').forEach(function(btn){
btn.addEventListener('click', function(){
var item = this.closest('.scusa-faq-item');
var isOpen = item.classList.contains('open');
document.querySelectorAll('.scusa-faq-item.open').forEach(function(i){ i.classList.remove('open'); });
if(!isOpen) item.classList.add('open');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-military-discount"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoot(root) {
    if (root.dataset.mdvReady) return;
    root.dataset.mdvReady = '1';
    var cards = root.querySelectorAll('.mdv-q');
    var titleOut = root.querySelector('[data-elig-title-out]');
    var copyOut = root.querySelector('[data-elig-copy-out]');
    if (!cards.length || !titleOut || !copyOut) return;
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-selected', 'false');
        });
        card.classList.add('is-active');
        card.setAttribute('aria-selected', 'true');
        titleOut.textContent = (card.getAttribute('data-elig-title') || '') + ' qualifies.';
        copyOut.textContent = card.getAttribute('data-elig-copy') || '';
      });
    });
  }
  function boot() {
    document.querySelectorAll('[data-mdv]').forEach(initRoot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  var q = e.target.closest('.pfaq__q');
  if(!q) return;
  var it = q.closest('.pfaq__item');
  var open = it.classList.toggle('pfaq--open');
  q.setAttribute('aria-expanded', open ? 'true' : 'false');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-accessory-lineup"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__scAR) return;
  window.__scAR = 1;
  function perView() { var w = window.innerWidth; return w <= 600 ? 1 : (w <= 900 ? 2 : 3); }
  function pageCount(m) { return Math.max(1, Math.ceil(m.querySelectorAll('.sc-ar__slide').length / perView())); }
  function buildDots(m) {
    var wrap = m.querySelector('.sc-ar__dots'); if (!wrap) return;
    var total = pageCount(m); wrap.innerHTML = '';
    for (var i = 0; i < total; i++) { var b = document.createElement('button'); b.type = 'button'; b.className = 'sc-ar__dot'; b.setAttribute('data-ar-dot', i); wrap.appendChild(b); }
  }
  function setPage(m, p) {
    var total = pageCount(m); if (p < 0) p = 0; if (p > total - 1) p = total - 1; m.__page = p;
    var vp = m.querySelector('.sc-ar__viewport'); if (vp) vp.scrollTo({ left: p * vp.clientWidth, behavior: 'smooth' });
    var dots = m.querySelectorAll('.sc-ar__dot');
    for (var i = 0; i < dots.length; i++) { if (i === p) dots[i].classList.add('is-active'); else dots[i].classList.remove('is-active'); }
  }
  function openModal(id) {
    var m = document.getElementById(id); if (!m) return;
    if (m.parentNode !== document.body) document.body.appendChild(m);
    m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    buildDots(m); setPage(m, 0);
  }
  function closeModal(m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-ar-open]'); if (o) { e.preventDefault(); openModal(o.getAttribute('data-ar-open')); return; }
    var c = e.target.closest('[data-ar-close]'); if (c) { var m1 = c.closest('.sc-ar__modal'); if (m1) closeModal(m1); return; }
    var p = e.target.closest('[data-ar-prev]'); if (p) { var m2 = p.closest('.sc-ar__modal'); if (m2) setPage(m2, (m2.__page || 0) - 1); return; }
    var n = e.target.closest('[data-ar-next]'); if (n) { var m3 = n.closest('.sc-ar__modal'); if (m3) setPage(m3, (m3.__page || 0) + 1); return; }
    var d = e.target.closest('[data-ar-dot]'); if (d) { var m4 = d.closest('.sc-ar__modal'); if (m4) setPage(m4, parseInt(d.getAttribute('data-ar-dot'), 10)); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var m = document.querySelector('.sc-ar__modal.is-open'); if (m) closeModal(m); } });
  window.addEventListener('resize', function () { var m = document.querySelector('.sc-ar__modal.is-open'); if (m) { buildDots(m); setPage(m, m.__page || 0); } });
})();

  } catch(e) { console.error(e); }
})();
})();
